/**
 * @fileoverview Match3 Game Layout
 * @description Stack navigation for Match3 game screens
 */

import { Stack } from "expo-router";
import { useThemeColors } from "@/providers/ThemeProvider";

export default function Match3Layout() {
  const colors = useThemeColors();

  return (
    <Stack
      screenOptions={{
        headerStyle: {
          backgroundColor: colors.surface,
        },
        headerTintColor: colors.text,
        headerTitleStyle: {
          fontWeight: "600",
        },
        headerShadowVisible: false,
        contentStyle: {
          backgroundColor: colors.background,
        },
      }}
    >
      <Stack.Screen
        name="index"
        options={{
          title: "Match 3",
          headerLargeTitle: true,
        }}
      />
      <Stack.Screen
        name="[sessionId]"
        options={{
          title: "Match 3",
          headerShown: false,
          gestureEnabled: false,
        }}
      />
    </Stack>
  );
}

